import { Navigate } from "react-router-dom";
import { auth } from "../firebase/firebase";
import { useAuthState } from "react-firebase-hooks/auth";

export default function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <p>Loading...</p>;

  // Example: Only allow specific admin email
  const adminEmail = "sonikathechef@gmail.com";

  if (user && user.email === adminEmail) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
}
